exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.preview-size[data-v-42288029] {\n  min-height: 300px;\n}\n\n/* .canvas-area {\n  max-width: 600px;\n} */\ncanvas[data-v-42288029] {\n  border: 0.5px solid #999;\n}\n.icon-bg[data-v-42288029] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #0b4e32;\n  border-radius: 9999px;\n  width: 2.25rem;\n  height: 2.25rem;\n  min-width: 2.25rem;\n  margin-right: 0.75rem;\n}\n.icon-s[data-v-42288029] {\n  color: #1bc47d;\n}\n", ""]);

// exports
